import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Textarea } from "@/components/ui/textarea";
import { ACCESSORY_FIELDS } from "@/utils/afsol";

const WizardStepCondition = ({ form, updateField }) => (
  <div className="space-y-4" data-testid="wizard-step-condition">
    {/* Ástand */}
    <div>
      <h3 className="text-xs font-semibold text-slate-700 uppercase tracking-wide mb-2">Ástand</h3>
      <div className="grid grid-cols-2 gap-x-4 gap-y-1.5">
        {[
          ["temporaryRegistered", "Bráðabirgðaskráð"],
          ["timingBeltChanged", "Tímareim skipt"],
          ["oilLeak", "Olíuleki"],
          ["oilBurn", "Olíubrenna"],
          ["coolantLeak", "Kælivökvale"],
          ["majorDamage", "Stórt tjón"],
          ["buyerInspected", "Kaupandi skoðað"],
        ].map(([key, label]) => (
          <label key={key} className="flex items-center gap-2 text-xs cursor-pointer">
            <Checkbox checked={form.condition[key]} onCheckedChange={(v) => updateField("condition", key, v)} data-testid={`wizard-cond-${key}`} />
            {label}
          </label>
        ))}
      </div>
      {form.condition.timingBeltChanged && (
        <div className="grid grid-cols-2 gap-3 mt-2">
          <div>
            <Label className="text-[10px] text-slate-500">Dags. tímareim skipt</Label>
            <Input value={form.condition.timingBeltDate || ""} onChange={(e) => updateField("condition", "timingBeltDate", e.target.value)} type="date" className="h-8 text-xs mt-0.5" data-testid="wizard-timing-belt-date" />
          </div>
          <div>
            <Label className="text-[10px] text-slate-500">Km staða við skipti</Label>
            <Input value={form.condition.timingBeltKm || ""} onChange={(e) => updateField("condition", "timingBeltKm", e.target.value)} type="text" placeholder="t.d. 120.000" className="h-8 text-xs mt-0.5" data-testid="wizard-timing-belt-km" />
          </div>
        </div>
      )}
      <Textarea
        value={form.condition.conditionComments || ""}
        onChange={(e) => updateField("condition", "conditionComments", e.target.value)}
        placeholder="Athugasemdir..."
        className="mt-2 text-xs h-16"
        data-testid="wizard-condition-comments"
      />
    </div>

    {/* Ábyrgðir */}
    <div>
      <h3 className="text-xs font-semibold text-slate-700 uppercase tracking-wide mb-2">Ábyrgðir</h3>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <Label className="text-[10px] text-slate-500">Miðlaraábyrgð gildir til</Label>
          <Input value={form.warranties.brokerWarrantyValidUntil || ""} onChange={(e) => updateField("warranties", "brokerWarrantyValidUntil", e.target.value)} type="date" className="h-8 text-xs mt-0.5" data-testid="wizard-warranty-date" />
        </div>
        <div>
          <Label className="text-[10px] text-slate-500">Miðlaraábyrgð km</Label>
          <Input value={form.warranties.brokerWarrantyValidKm || ""} onChange={(e) => updateField("warranties", "brokerWarrantyValidKm", e.target.value)} className="h-8 text-xs mt-0.5" data-testid="wizard-warranty-km" />
        </div>
      </div>
    </div>

    {/* Fylgihlutir */}
    <div>
      <h3 className="text-xs font-semibold text-slate-700 uppercase tracking-wide mb-2">Fylgihlutir</h3>
      <div className="grid grid-cols-2 gap-x-4 gap-y-1.5">
        {ACCESSORY_FIELDS.map(({ key, label }) => (
          <label key={key} className="flex items-center gap-2 text-xs cursor-pointer">
            <Checkbox checked={form.accessories[key]} onCheckedChange={(v) => updateField("accessories", key, v)} data-testid={`wizard-acc-${key}`} />
            {label}
          </label>
        ))}
      </div>
    </div>
  </div>
);

export default WizardStepCondition;
